import React from 'react';
import { supaGet, supaSet } from "../supabase.js";

// ─────────────────────────────────────────────────────────────────────────────
// SecFinJournee — recense les fins de journée où un salarié (hors encadrement
// renforcé, voir Lot C) a signalé un rapport encore non confirmé (file locale
// du lot 1) ou un appartement non pointé. Source = journal7, entrées
// action==='fin_journee_anomalie' (voir SPEC_file_locale_v2.md §2 déc. #6).
//
// Le salarié ne peut rien réparer lui-même à ce stade — le signalement sert
// uniquement à ce que la Direction vérifie. « Traité » marque l'entrée sans la
// supprimer (append-only, même pattern que assist7/AssistanceBanner).
// ─────────────────────────────────────────────────────────────────────────────

const fmtDt=ts=>{
  if(!ts)return '?';
  try{return new Date(ts).toLocaleString('fr-FR',{day:'2-digit',month:'2-digit',year:'2-digit',hour:'2-digit',minute:'2-digit'});}
  catch(_){return '?';}
};

export function SecFinJournee({journal,setJournal,sess}){
  const entries=(journal||[]).filter(e=>e.action==='fin_journee_anomalie').sort((a,b)=>String(b.ts).localeCompare(String(a.ts)));
  const actives=entries.filter(e=>!e.traite);
  const traitees=entries.filter(e=>e.traite);
  const parNom=sess?.email||sess?.name||'Direction';

  const traiter=async(id)=>{
    try{
      const base=await supaGet('journal7')||[];
      const merged=base.map(e=>e.id===id?{...e,traite:true,traitePar:parNom,traiteTs:new Date().toISOString()}:e);
      await supaSet('journal7',merged);setJournal(merged);
    }catch(e){
      console.error('[fin journée traité] écriture échouée :',e.message);
      setJournal(js=>(js||[]).map(x=>x.id===id?{...x,traite:true,traitePar:parNom,traiteTs:new Date().toISOString()}:x));
    }
  };

  const renderEntry=e=>(
    <div key={e.id} style={{background:'#fff',border:'1px solid var(--li)',borderLeft:`4px solid ${e.traite?'var(--ok)':'#ef4444'}`,borderRadius:8,padding:'10px 14px',marginBottom:8}}>
      <div style={{display:'flex',justifyContent:'space-between',flexWrap:'wrap',gap:8,alignItems:'center'}}>
        <div style={{fontWeight:700,fontSize:13}}>{e.qui||'Salarié(e)'}</div>
        <div style={{fontSize:11,color:'var(--si)'}}>{fmtDt(e.ts)} · {e.cible}</div>
      </div>
      <div style={{fontSize:12,marginTop:4,color:'var(--si)'}}>{e.detail}</div>
      {e.traite&&<div style={{fontSize:11,color:'var(--ok)',marginTop:4}}>✓ Traité par {e.traitePar} — {fmtDt(e.traiteTs)}</div>}
      {!e.traite&&<div style={{marginTop:8,display:'flex',justifyContent:'flex-end'}}>
        <button onClick={()=>traiter(e.id)} className="btn bgh sm" style={{fontSize:11}}>✓ Traité</button>
      </div>}
    </div>
  );

  return(<div style={{padding:'16px'}}>
    <div className="D" style={{fontSize:18,marginBottom:4}}>📋 Fin de journée avec anomalie</div>
    <div style={{fontSize:12,color:'var(--si)',marginBottom:16,maxWidth:640}}>
      Un salarié a signalé, au moment de sa fin de poste, un rapport encore en attente d'envoi ou un
      appartement non pointé. Il ne peut rien y faire de plus — c'est à vérifier ici. Réservé aux
      salariés hors encadrement renforcé (eux passent par la clôture attestée, onglet RH).
    </div>
    {entries.length===0&&<div className="empty">Aucun signalement enregistré. 👍</div>}
    {actives.length>0&&<>
      <div style={{fontSize:11,fontWeight:700,color:'var(--si)',textTransform:'uppercase',marginBottom:6}}>À traiter ({actives.length})</div>
      {actives.map(renderEntry)}
    </>}
    {traitees.length>0&&<details style={{marginTop:12}}>
      <summary style={{fontSize:12,color:'var(--si)',cursor:'pointer'}}>Déjà traités ({traitees.length})</summary>
      <div style={{marginTop:8}}>{traitees.map(renderEntry)}</div>
    </details>}
  </div>);
}
